import { render, staticRenderFns } from "./catBusinessShop.vue?vue&type=template&id=304a4fd2&scoped=true"
import script from "./catBusinessShop.vue?vue&type=script&lang=js"
export * from "./catBusinessShop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "304a4fd2",
  null
  
)

export default component.exports